import { c as _c } from "react/compiler-runtime";
import { FormImages } from "@/components/Inputs/FormInputs/form-images/FormImages";
import { PhotoPreviewGroup } from "@/components/molecules/PhotoPreviewGroup/PhotoPreviewGroup";
import { useNewRoomListingImagesForm } from "./useNewRoomListingImagesForm";
export function NewRoomListingImagesForm() {
  const $ = _c(23);
  const {
    isMobile,
    t,
    maxImageSizeMB,
    MAX_IMAGE_SIZE,
    MAX_IMAGES,
    propertyImages
  } = useNewRoomListingImagesForm();
  let t0;
  if ($[0] !== isMobile || $[1] !== t) {
    t0 = isMobile ? undefined : t("title");
    $[0] = isMobile;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== MAX_IMAGES || $[4] !== maxImageSizeMB || $[5] !== t) {
    t1 = t("description", {
      maxImages: MAX_IMAGES,
      maxSize: maxImageSizeMB
    });
    $[3] = MAX_IMAGES;
    $[4] = maxImageSizeMB;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== MAX_IMAGES || $[8] !== MAX_IMAGE_SIZE || $[9] !== t0 || $[10] !== t1) {
    t2 = <FormImages name="images" label={t0} description={t1} maxImages={MAX_IMAGES} maxImageSize={MAX_IMAGE_SIZE} className="h-full" data-sentry-element="FormImages" data-sentry-source-file="NewRoomListingImagesForm.tsx" />;
    $[7] = MAX_IMAGES;
    $[8] = MAX_IMAGE_SIZE;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t) {
    t3 = t("propertyPhotosLabel");
    $[12] = t;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t) {
    t4 = t("propertyPhotosDescription");
    $[14] = t;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== propertyImages || $[17] !== t3 || $[18] !== t4) {
    t5 = <PhotoPreviewGroup label={t3} description={t4} photos={propertyImages} columns={4} columnsMd={8} data-sentry-element="PhotoPreviewGroup" data-sentry-source-file="NewRoomListingImagesForm.tsx" />;
    $[16] = propertyImages;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t2 || $[21] !== t5) {
    t6 = <div className="flex flex-col gap-6" data-sentry-component="NewRoomListingImagesForm" data-sentry-source-file="NewRoomListingImagesForm.tsx">{t2}{t5}</div>;
    $[20] = t2;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}